import { Fragment } from "react";
import Footer from "../modules/public/footer/footer";
import Menu from "../modules/public/menu/menu";

function NotFound404() {
  return (
    <Fragment>
      <Menu />
      <section className="d-flex flex-wrap justify-content-center align-items-center flex-grow-1">
        <div style={{ maxWidth: 500 }}>
          <img src="/postupPics/not-found.jpg" className="w-100" />
        </div>

        <div>
          <h1 className="text-center" style={{ fontSize: 56 }}>
            404
          </h1>
          <h4>صفحه ی مورد نظر پیدا نشد</h4>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
}
export default NotFound404;
